// Javascripts for this application

import "vendor/actiontext"
import "vendor/iconizer"

import("./controllers")